//

class FrontendException {
  constructor(label) {
    this.label = label;
  }
}

export default FrontendException;